export default __webpack_public_path__ + "static/media/1.82ebad46.jpg";